import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Input,
  Button,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardDrugResuscitationUx = (props: any) => {
    return(
      <div
        id="CardDrugResuscitationUx-div-0"
        style={{margin: "10px", backgroundColor: "#F3F3F3", height:"90%"}}>
        <div
          className="ui form"
          id="CardDrugResuscitationUx-div-40"
          style={{ padding: "15px"}}>
          
          <FormGroup
            id="CardDrugResuscitationUx-FormGroup-41"
            inline={true}>
            <FormField
              id="CardDrugResuscitationUx-FormField-43"
              inline={true}
              width="3">
              <label
                id="CardDrugResuscitationUx-label-46"
                style={{minWidth: "fit-content"}}>
                {props.languageUX === "en" ? "Preparing box No." : "เลขที่ใบจัดกล่อง"}
              </label>
              <Input
                icon="search"
                id="CardDrugResuscitationUx-Input-47"
                name="filterBox.code"
                onChange={props.handleChangeData}
                style={{width:"100%"}}
                value={props.DrugResuscitationSequence?.filterBox?.code || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugResuscitationUx-FormField-44"
              inline={true}
              style={{ marginLeft: "10px" }}
              width="5">
              <div
                id="CardDrugResuscitationUx-div-66"
                style={{display: "flex",width:"100%", gap:"10px",alignItems:"center"}}>
                
                <label
                  id="CardDrugResuscitationUx-label-48"
                  style={{minWidth: "fit-content",  fontWeight:"bold",fontSize:"13px"}}>
                  {props.languageUX === "en" ? "Created date of medicine box" : "วันที่สร้างกล่องยา"}
                </label>
                <DateTextBox
                  id="CardDrugResuscitationUx-DateTextBox-50"
                  onChange={props.handleChangeStartDate}
                  value={props.DrugResuscitationSequence?.filterBox?.created_start || ""}>
                </DateTextBox>
                <label
                  id="CardDrugResuscitationUx-label-55"
                  style={{minWidth: "fit-content",  fontWeight: "bold",fontSize:"13px"}}>
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </label>
                <DateTextBox
                  id="CardDrugResuscitationUx-DateTextBox-56"
                  onChange={props.handleChangeEndDate}
                  value={props.DrugResuscitationSequence?.filterBox?.created_end || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardDrugResuscitationUx-FormField-45"
              inline={true}
              style={{ marginLeft: "5px" }}
              width="3">
              <label
                id="CardDrugResuscitationUx-label-52"
                style={{minWidth: "fit-content"}}>
                {props.languageUX === "en" ? "Box number" : "เลขที่กล่อง"}
              </label>
              <Input
                id="CardDrugResuscitationUx-Input-53"
                name="filterBox.container_code"
                onChange={props.handleChangeData}
                style={{width:"100%"}}
                value={props.DrugResuscitationSequence?.filterBox?.container_code || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugResuscitationUx-FormField-57"
              inline={true}
              style={{ display: "flex", justifyContent: "flex-end" }}
              width="5">
              <div
                id="CardDrugResuscitationUx-div-58">
                {props.buttonSearchBox}
              </div>
              <Button
                color="blue"
                id="CardDrugResuscitationUx-Button-59"
                onClick={props.addNewClick}
                size="small"
                style={{display: props.isNurseScreen ? "none" : "flex", margin: "0px 4px 0px 5px"}}>
                {props.languageUX === "en" ? "Add a medicine box" : "เพิ่มใบจัดกล่องยา"}
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDrugResuscitationUx-FormGroup-42"
            inline={true}>
            <FormField
              id="CardDrugResuscitationUx-FormField-60"
              inline={true}
              width="3">
              <label
                id="CardDrugResuscitationUx-label-62"
                style={{minWidth: "fit-content"}}>
                {props.languageUX === "en" ? "Name of medicine box" : "ชื่อกล่องยา"}
              </label>
              <Input
                id="CardDrugResuscitationUx-Input-64"
                name="filterBox.container_name"
                onChange={props.handleChangeData}
                style={{width:"100%"}}
                value={props.DrugResuscitationSequence?.filterBox?.container_name || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugResuscitationUx-FormField-61"
              inline={true}
              width="3">
              <label
                id="CardDrugResuscitationUx-label-63"
                style={{minWidth: "fit-content"}}>
                {props.languageUX === "en" ? "status" : "สถานะ"}
              </label>
              <Dropdown
                clearable={true}
                id="CardDrugResuscitationUx-Dropdown-65"
                name="filterBox.status"
                onChange={props.handleChangeData}
                options={props.statusTypeItems || []}
                search={true}
                selection={true}
                style={{width:"100%"}}
                value={props.DrugResuscitationSequence?.filterBox?.status || ""}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardDrugResuscitationUx-div-14"
          style={{ height: "20%", position: "relative", padding: "15px" }}>
          
          <Table
            columns={props.columnsBoxItem}
            data={props?.boxItems}
            getTrProps={props.boxTableRowProps}
            id="CardDrugResuscitationUx-Table-15"
            showPagination={false}
            style={{fontSize: "medium", height: "20vh"}}>
          </Table>
        </div>
        <div
          id="CardDrugResuscitationUx-div-16"
          style={{ height: "50%", position: "relative", padding: "15px" }}>
          {props.container}
        </div>
      </div>
    )
}


export default CardDrugResuscitationUx

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-div-0"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"10px\", backgroundColor: \"#F3F3F3\", height:\"90%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"20%\", position: \"relative\", padding: \"15px\" }"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 15,
      "name": "Table",
      "parent": 14,
      "props": {
        "columns": {
          "type": "code",
          "value": "props.columnsBoxItem"
        },
        "data": {
          "type": "code",
          "value": "props?.boxItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.boxTableRowProps"
        },
        "headers": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-Table-15"
        },
        "keys": {
          "type": "value",
          "value": ""
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"medium\", height: \"20vh\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.container"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-div-16"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"50%\", position: \"relative\", padding: \"15px\" }"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-div-40"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"15px\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormGroup",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-FormGroup-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormGroup",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-FormGroup-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\" }"
        },
        "width": {
          "type": "value",
          "value": "5"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"5px\" }"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบจัดกล่อง",
          "valueEN": "Preparing box No."
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-label-46"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"fit-content\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Input",
      "parent": 43,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-Input-47"
        },
        "name": {
          "type": "value",
          "value": "filterBox.code"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugResuscitationSequence?.filterBox?.code || \"\""
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สร้างกล่องยา",
          "valueEN": "Created date of medicine box"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-label-48"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"fit-content\",  fontWeight:\"bold\",fontSize:\"13px\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 50,
      "name": "DateTextBox",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-DateTextBox-50"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeStartDate"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.DrugResuscitationSequence?.filterBox?.created_start || \"\""
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่กล่อง",
          "valueEN": "Box number"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-label-52"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"fit-content\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Input",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-Input-53"
        },
        "name": {
          "type": "value",
          "value": "filterBox.container_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugResuscitationSequence?.filterBox?.container_code || \"\""
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-label-55"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"fit-content\",  fontWeight: \"bold\",fontSize:\"13px\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 56,
      "name": "DateTextBox",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-DateTextBox-56"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeEndDate"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.DrugResuscitationSequence?.filterBox?.created_end || \"\""
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-FormField-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        },
        "width": {
          "type": "value",
          "value": "5"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-div-58"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Button",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มใบจัดกล่องยา",
          "valueEN": "Add a medicine box"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-Button-59"
        },
        "onClick": {
          "type": "code",
          "value": "props.addNewClick"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isNurseScreen ? \"none\" : \"flex\", margin: \"0px 4px 0px 5px\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 42,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-FormField-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 42,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-FormField-61"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "label",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อกล่องยา",
          "valueEN": "Name of medicine box"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-label-62"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"fit-content\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "label",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-label-63"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"fit-content\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Input",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-Input-64"
        },
        "name": {
          "type": "value",
          "value": "filterBox.container_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugResuscitationSequence?.filterBox?.container_name || \"\""
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Dropdown",
      "parent": 61,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-Dropdown-65"
        },
        "name": {
          "type": "value",
          "value": "filterBox.status"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.statusTypeItems || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.DrugResuscitationSequence?.filterBox?.status || \"\""
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugResuscitationUx-div-66"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",width:\"100%\", gap:\"10px\",alignItems:\"center\"}"
        }
      },
      "seq": 66,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugResuscitationUx",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
